import imageOne from '@/assets/images/cities/winnipeg1.jpg'
import imageTwo from '@/assets/images/cities/winnipeg2.jpg'
import imageThree from '@/assets/images/cities/winnipeg3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Winnipeg',
  writeup: '',
  website: 'MyWinnipegNotaryPublic.com',
  url: 'https://www.mywinnipegnotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(204) 515-3422',
      hours: {
        monday: '11:00AM to 4:30PM',
        tuesday: '11:00AM to 4:30PM',
        wednesday: '11:00AM to 4:30PM',
        thursday: '11:00AM to 4:30PM',
        friday: '11:00AM to 4:30PM',
        saturday: 'Closed',
        sunday: 'Closed'
      },
      address: 'Portage Avenue Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/manitoba/cities/winnipeg.js